// extracted by mini-css-extract-plugin
export default {"container":"CartItems_container__gQWCF","priceCont":"CartItems_priceCont__9hihP","itemCont":"CartItems_itemCont__ABJ56","start":"CartItems_start__zagoz"};